import {Component, Input, OnInit} from '@angular/core'
import {AuthService} from '../../../services/auth.service'
import {AdminV1} from '../../../interfaces/userLogin'
import {NzModalRef} from 'ng-zorro-antd/modal'
import {NotificatorService} from '../../../services/notificator.service'

@Component({
    selector: 'app-login-as-company',
    templateUrl: './login.as.company.component.html',
    styleUrls: ['./login.as.company.component.css'],
    standalone: false
})

export class LoginAsCompanyComponent implements OnInit {

  @Input() modalMode?: boolean
  companies: AdminV1[]
  foundCompanies: AdminV1[]
  loaded: boolean
  login: boolean
  selectedCompany: AdminV1

  private lsVarName = 'LOGIN_AS_COMPANY'
  nzFilterOption = (): boolean => true

  /**
   * Search by several fields
   * @param value
   */
  search(value: string): void {
    const test = (field: string | null | undefined) => {
      if ([undefined, null, ''].indexOf(field) < 0) {
        return field.includes(value)
      } else {
        return false
      }
    }
    this.foundCompanies = this.companies.filter(t => {
      if (value === null || value === '') {
        return true
      } else {
        if (
          test(t.company) ||
          test(t.administrator) ||
          test(t.adminId) ||
          test(t.fax) ||
          test(t.phone) ||
          test(t.email)
        ) {
          return true
        }
      }
      return false
    })
  }

  /**
   * Close modal without callback
   */
  destroyModal(): void {
    this.modal.destroy()
  }

  /**
   * logout of company
   */
  logout() {
    this.AUTH.deactivateCompanyView()
  }

  /**
   * [DONE] - save login and close modal within OK-callback
   */
  select() {
    if (this.selectedCompany) {
      this.AUTH.activateCompanyView(this.selectedCompany)
    } else {
      this.notify.createTopMessage('Nothing was Selected', 'error', 2000)
    }
  }

  /**
   * init modal if login as company
   */
  initChosenCompany() {
    const get = localStorage.getItem(this.lsVarName)
    if (get !== null) {
      const cp = JSON.parse(get)
      this.selectedCompany = this.companies
        .find(c => c.company === cp.company && c.adminId === cp.adminId)
      this.login = true
    }
  }

  constructor(
    private AUTH: AuthService,
    private modal: NzModalRef,
    private notify: NotificatorService
  ) {
  }

  ngOnInit() {
    console.log('LOGIN-AS-COMPANY: ', this)
    this.AUTH.getAllAdmins(true)
      .then(res => {
        this.companies = res
        this.foundCompanies = [...res]
        this.initChosenCompany()
        this.loaded = true
      }, error => {
        console.log('error get admins: ', error)
      })
  }

}
